import { useState } from 'react';

export const useForceUpdate = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	let [value, setState] = useState(true);
	return () => setState(val => !val);
};
